import React, { useState, useEffect } from 'react';
import useAxios from 'hooks/useAxios';
import { Button, Card, CardBody, Input, FormGroup, Label, Row, Col } from 'reactstrap';
import { Nav, NavItem, TabContent, TabPane } from 'reactstrap';
import classNames from 'classnames';
import { NavLink } from 'react-router-dom';
import ErrorBoundary from 'components/ErrorBoundary';
import SpecialDrugDetails from './Top10SpecialDrugDetails'
import TopSpecialityDrugsByPMPMSummary from './TopSpecialityDrugsByPMPMSummary';
const TopSpecialityDrugsByPMPMDrawer =(props)=>{
    const [activeTab, setActiveTab] = useState('1');
    const {dateRange, pbmPlanId, pbmGroupID,planCode, startDate, endDate,rebateflag,groupCode} = props.searchData;
    const{onHandleIsOpen}=props;
    const [initialFilters, setInitialFilters] = useState({
      currentPage: 1,
      pageSize: 10,
      orderBy: '',
      order: '',
      groupId:pbmGroupID,
      planCode:planCode,
    //  graphClaimStatus:graphClaimStatus,
    claimStatus :'Approved',
      dateRange : dateRange,
      startDate : startDate,
      endDate : endDate,
      rebateflag:rebateflag,
      filters: [],
    });
     const [PSSinitialFilters, setPSSInitialFilters] = useState({
        currentPage: 1,
      pageSize: 10,
      orderBy: '',
      order: '',
      groupId:pbmGroupID,
      planCode:planCode,
    //  graphClaimStatus:graphClaimStatus,
      dateRange : dateRange,
      startDate : startDate,
      endDate : endDate,
      rebateflag:rebateflag,
      groupCode: groupCode,
      filters: [],
    });
    const handleBack = ()=>{
        onHandleIsOpen();
      }
      const toggle = (tab) => {
        if (activeTab !== tab) {
          setActiveTab(tab);
        }
      };
      

      return (
        <div>
          <Nav tabs className='border-0 px-3 py-0'>
            <NavItem>
              <NavLink
                to=""
                className={classNames({
                  activeState: activeTab === '1',
                })}
                onClick={() => {
                  toggle('1');
                }}
              >
                Summary Report
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                to=""		  
                className={classNames({
                  activeState: activeTab === '2',
                })}
                onClick={() => {
                  toggle('2');
                }}
              >
                Detailed Report
              </NavLink>
            </NavItem>
          </Nav>
          <hr className='mb-0 mt-2' />
          <TabContent activeTab={activeTab} className='px-3 mt-0 pt-0'>
            <TabPane tabId='1' >
                <ErrorBoundary>
                   <TopSpecialityDrugsByPMPMSummary dateRange={dateRange} planId={pbmPlanId} groupId={pbmGroupID} filter={PSSinitialFilters}/>
                </ErrorBoundary>
            
            </TabPane>
            <TabPane tabId='2'>
                <ErrorBoundary>
            <SpecialDrugDetails dateRange={dateRange} planId={pbmPlanId} groupId={pbmGroupID} filter={initialFilters}/>
                </ErrorBoundary>
            </TabPane>
          </TabContent>
        </div>
      );
}

export default TopSpecialityDrugsByPMPMDrawer;